let themeSettings = {}

export const useThemeSettings = () => themeSettings

export const useSetThemeSettings = (settings) => setThemeSettings(settings)

const setThemeSettings = (settings) => {
  themeSettings = settings ? { ...themeSettings, ...settings } : {}
}
